"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.pickFields = void 0;
var pickFields = function (o) {
    var fields = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        fields[_i - 1] = arguments[_i];
    }
    return fields.reduce(function (a, x) {
        if (o.hasOwnProperty(x))
            a[x] = o[x];
        return a;
    }, {});
};
exports.pickFields = pickFields;
